import {getPageTitle} from '~/utils/seoUtils'
import {isEmpty, isObject} from "lodash"
import {getPageMetadata} from 'assets/staticPagesSeo'

export function useCustomSEOData(data, options = {defaultRobots: 'noindex,nofollow', reverseTitle: false}) {
  if (!data || !isObject(data) || isEmpty(data)) {
    console.warn('useCustomSEOData: pageId is required')
    return
  }
  const currentPageData = ref(data)

  const setMetas = (data) => {
    const config = useRuntimeConfig()
    data.title = getPageTitle(data.title, config.public.pageTitle, options?.reverseTitle || false)
    useHead(data)
  }

  const setPageData = (data) => {
    currentPageData.value = data
  }

  watch(currentPageData, () => {
    const pageMetas = getPageMetadata(currentPageData.value)
    if(!pageMetas || isEmpty(pageMetas)) return

    setMetas(pageMetas)
  }, {immediate: true})

  return {
    setPageData
  }
}
